import React from 'react';

export interface ClientConfiguration {
	baseUrl: string;
	clientId: string;
	region?: string;
}
const emptyConfig: ClientConfiguration = { baseUrl: '', clientId: '' };

const ClientConfigurationContext = React.createContext<ClientConfiguration>(emptyConfig);
export default ClientConfigurationContext;

export let getConfiguration = (): ClientConfiguration => { throw Error("NOT_SET") };

export const ClientConfigurationProvider = (props: { children: any }) => {
	const [config, setConfig] = React.useState<ClientConfiguration>();

	React.useEffect(() => {
		const abortController = new AbortController();
		const get = async () => {
			try {
				const result = await fetch('ClientConfiguration', { signal: abortController.signal });
				if (result.status === 200) {
					const json = await result.json();
					if (typeof json === 'object') {
						setConfig(json)
					}
				}
			}
			catch (reason) {
				console.error(reason)
			}
		}

		get();
		return () => abortController.abort();
	}, [])

	getConfiguration = () => config || emptyConfig;

	return (
		<ClientConfigurationContext.Provider value={config || emptyConfig}>
			{config !== undefined && props.children}
		</ClientConfigurationContext.Provider>
	)
}